const Controls = () => {
    return null; // No controls needed anymore
};

export default Controls;
